import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CartContext } from '@rsc/contexts/CartContext';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';
import Button from '../button';
import IconLock from '../svgs/lock.svg';
import sharedStyles from '../styles';

const Wrapper = styled.div`
  padding: ${sharedStyles.spacing['spacing-md']}
    ${sharedStyles.spacing['spacing-md']} ${sharedStyles.spacing['spacing-lg']};
  button {
    width: 100%;
    max-width: 18rem;
    display: block;
    margin: 0 auto;
  }
  @supports (-webkit-touch-callout: none) {
    padding-bottom: 6.875rem;
  }
`;

const CheckoutSummaryLines = styled.ul`
  padding: 0;
  margin: 0;
  margin-bottom: ${sharedStyles.spacing['spacing-lg']};
  li {
    display: flex;
    margin-bottom: ${sharedStyles.spacing['spacing-md']};
    font-size: ${sharedStyles.fontSize.base};
    font-weight: ${sharedStyles.fontWeight.bold};

    span {
      flex: 1;
      &:last-child {
        flex: none;
        text-align: right;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const CheckoutButtonInner = styled.span`
  svg {
    margin-right: ${sharedStyles.spacing['spacing-1xs']};
  }
`;

function CheckoutArea({ subtotalPrice, checkoutUrl }) {
  const { formatPrice } = useContext(CartContext);
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Wrapper>
      <CheckoutSummaryLines>
        <li>
          <span>{tt(s => s.cartCommon.checkoutSummarySubtotal)}</span>
          <span>{formatPrice(subtotalPrice)}</span>
        </li>
        <li>{tt(s => s.cartCommon.taxShippingCalculatedInCheckout)}</li>
      </CheckoutSummaryLines>
      <Button
        tabIndex={0}
        onClick={() => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'gatsby-begin-checkout',
          });
          localStorage.setItem('checkoutActive', true);
          window.location.href = checkoutUrl;
        }}
      >
        <CheckoutButtonInner>
          <IconLock width="12" height="12" fill="white" />
          {tt(s => s.cartCommon.secureCheckoutButton)}
        </CheckoutButtonInner>
      </Button>
    </Wrapper>
  );
}

CheckoutArea.propTypes = {
  subtotalPrice: PropTypes.string.isRequired,
  checkoutUrl: PropTypes.string.isRequired,
};

export default CheckoutArea;
